import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import Section0 from "./components/section0/Section0";
import Section1 from "./components/section1/Section1";
import Section2 from "./components/section2/Section2";
import Section3 from "./components/section3/Section3";
import Navbar from "./components/navbar/Navbar";
import LeadInquiryModal from "./components/LeadInquiryModal";
import ThankYou from "./components/ThankYou";
import { installPhoneConversionTracking } from "./phoneConversionTracking";

const App: React.FC = () => {
  useEffect(() => installPhoneConversionTracking(), []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <Navbar />
              <Section0 />
              <Section1 />
              <Section2 />
              <Section3 />
              <LeadInquiryModal />
            </div>
          }
        />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;

